export default attributes => {
  const { specialOfferType } = attributes

  const type = {
    textOnlyOffer: false,
    isSetBundleOffer: false,
    isBuilderOffer: false
  }

  type.textOnlyOffer =
    specialOfferType === 'basic-text-only' ||
    (typeof attributes.productSets !== 'undefined' && attributes.productSets.some(set => set.products.length > 200)) ||
    (typeof attributes.productSets !== 'undefined' &&
      attributes.productSets?.length === 1 &&
      attributes.productSets?.[0].minimumBuyQuantity === 1)

  type.isSetBundleOffer =
    typeof attributes.productSets !== 'undefined' &&
    attributes.productSets.filter(set => !set.host).length &&
    attributes.productSets.filter(set => !set.host).every(set => set.products.length === 1)

  type.isBuilderOffer = !type.textOnlyOffer && !type.isSetBundleOffer

  return type
}
